import React, { memo } from 'react';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { useInstantSearch } from 'react-instantsearch-hooks-web';
import SearchHero from '../SearchHero/SearchHero';

interface SearchResultsHeroProps {
  hero_background_image: StoryblokAsset;
  hero_heading: string;
  hero_body?: string;
  hero_search_bar_placeholder: string;
}

const SearchResultsHero: React.FC<SearchResultsHeroProps> = ({
  hero_background_image,
  hero_heading,
  hero_body = undefined,
  hero_search_bar_placeholder,
}) => {
  const {
    results: { nbHits },
  } = useInstantSearch();

  const HeroBody = (props: { text: string; nbHits: number }): JSX.Element => {
    const words: string[] = props.text.split(' ');
    const placeholderText: string = '<number_of_results>';
    return (
      <p className="text-text/body text-lg font-bold">
        {words.map((word: string, index: number) =>
          word === placeholderText ? (
            <span key={nbHits} className="text-text/body-accent">{`${
              props.nbHits
            }${index < words.length - 1 ? ' ' : ''}`}</span>
          ) : (
            `${word}${index < words.length - 1 ? ' ' : ''}`
          )
        )}
      </p>
    );
  };

  return (
    <SearchHero
      hero_background_image={hero_background_image}
      hero_heading={hero_heading}
      hero_body={hero_body && <HeroBody text={hero_body} nbHits={nbHits} />}
      hero_search_bar_placeholder={hero_search_bar_placeholder}
    />
  );
};

export default memo(SearchResultsHero);
